// ABOUTME: Role constant gating the variant pricing explain trace UI.
// ABOUTME: Mirrors CPQ_PRICING_DEBUG_ROLE on the server; a feature role, not a UI_APPBAR_* nav role.

export const CPQ_PRICING_DEBUG_ROLE = 'CPQ_PRICING_DEBUG';
